module.exports = __webpack_public_path__ + "img/29.1ef96b36.png";